(function () {
  const pt = document.getElementById("pt");
  const path = pt && pt.querySelector(".pt__path");
  const text = pt && pt.querySelector(".pt__text");

  if (!pt || !path) {
    console.error("[PT] overlay missing");
    return;
  }

  const force = pt.hasAttribute("data-pt-force");
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced && !force) return;

  if (!window.gsap) {
    console.error("[PT] GSAP missing");
    return;
  }

  // Stop the browser doing its own weird scroll restore with PJAX
  try { history.scrollRestoration = "manual"; } catch (e) {}

  const P = {
    s1u: "M 0 0 h 0 c 0 50 0 50 0 100 H 0 V 0 Z",
    s1m: "M 0 0 h 43 c -60 55 140 65 0 100 H 0 V 0 Z",
    s1f: "M 0 0 h 100 c 0 50 0 50 0 100 H 0 V 0 Z",
    s2f: "M 100 0 H 0 c 0 50 0 50 0 100 h 100 V 50 Z",
    s2m: "M 100 0 H 50 c 28 43 4 81 0 100 h 50 V 0 Z",
    s2u: "M 100 0 H 100 c 0 50 0 50 0 100 h 0 V 0 Z",
  };

  function coverUntilBlack() {
    return new Promise((resolve) => {
      gsap.timeline({ paused: true })
        .set(path, { attr: { d: P.s1u } })
        .to(path, { duration: 0.5, ease: "power3.in", attr: { d: P.s1m } })
        .to(path, { duration: 0.5, ease: "power1", attr: { d: P.s1f }, onComplete: resolve })
        .set(path, { attr: { d: P.s2f } })
        .play(0);
    });
  }

  function unveil() {
    const tl = gsap.timeline();
    if (text) tl.to(text, { duration: 0.12, autoAlpha: 0, ease: "power2.in" }, 0);
    tl.to(path, { duration: 0.2, ease: "sine.in", attr: { d: P.s2m } }, 0.02)
      .to(path, { duration: 1.0, ease: "power4", attr: { d: P.s2u } });
    return tl;
  }

  function isLocal(href) {
    try {
      const u = new URL(href, location.href);
      return u.origin === location.origin;
    } catch (e) {
      return false;
    }
  }

  function shouldSkip(a, e) {
    if (!a) return true;
    const href = a.getAttribute("href") || "";

    if (a.hasAttribute("data-pt-skip")) return true;
    if (a.target && a.target !== "_self") return true;

    // Respect new-tab intents
    if (e && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return true;

    if (href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) return true;
    if (!isLocal(href)) return true;
    if (a.closest('form,[data-product-form],[data-action="toggle-drawer"]')) return true;
    if (/\/(cart|checkout)/.test(href)) return true;

    return false;
  }

  function timeout(ms) {
    return new Promise((_, rej) => setTimeout(() => rej(new Error("timeout " + ms + "ms")), ms));
  }

  async function fetchDoc(url, ms) {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), ms);
    try {
      const res = await fetch(url, {
        credentials: "include",
        signal: ctrl.signal,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!res.ok) throw new Error("status " + res.status);
      const html = await res.text();
      return new DOMParser().parseFromString(html, "text/html");
    } finally {
      clearTimeout(t);
    }
  }

  function waitForReady(scope) {
    const imgs = Array.from(scope.querySelectorAll("img"));
    const decodes = imgs.map((i) => (i.decode ? i.decode().catch(() => {}) : Promise.resolve()));
    const fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    const raf2 = new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
    return Promise.race([Promise.all([Promise.all(decodes), fonts, raf2]), timeout(2500)]).catch(() => {});
  }

  // Only run scripts you explicitly mark with data-pt-run
  function runMarkedScripts(scope) {
    const scripts = Array.from(scope.querySelectorAll("script[data-pt-run]"));

    scripts.forEach((old) => {
      const s = document.createElement("script");

      // Copy attributes except id (avoid duplicates)
      for (const attr of old.attributes) {
        if (attr.name === "id") continue;
        s.setAttribute(attr.name, attr.value);
      }

      if (old.src) {
        s.src = old.src;
        s.async = false;
      } else {
        s.textContent = old.textContent || "";
      }

      // Replace old script node so it won’t run twice if you ever re-scan
      old.parentNode && old.parentNode.replaceChild(s, old);
    });
  }

  function replaceMain(doc) {
    const newMain = doc.querySelector("#MainContent") || doc.querySelector("main");
    const oldMain = document.querySelector("#MainContent") || document.querySelector("main");
    if (!newMain || !oldMain) throw new Error("Main container not found");

    document.dispatchEvent(new CustomEvent("pt:before-swap"));

    oldMain.replaceWith(newMain);

    if (doc.title) document.title = doc.title;
    if (doc.body && doc.body.className != null) document.body.className = doc.body.className;

    return newMain;
  }

  function fireAfterSwap(scope) {
    document.dispatchEvent(new CustomEvent("pt:after-swap", { detail: { scope } }));
    document.dispatchEvent(new CustomEvent("shopify:section:unload"));
    document.dispatchEvent(new CustomEvent("shopify:section:load"));
  }

  let isNavigating = false;

  async function pjax(url, opts) {
    opts = opts || {};
    if (isNavigating) return;
    isNavigating = true;

    let hard = false;

    try {
      await coverUntilBlack();

      if (text) {
        gsap.set(text, { autoAlpha: 0 });
        pt.classList.add("pt--loading");
        gsap.to(text, { duration: 0.18, autoAlpha: 1, ease: "power2.out" });
      }

      const doc = await fetchDoc(url, 8000);

      if (!opts.fromPopstate) {
        history.pushState({ url }, "", url);
      }

      const scope = replaceMain(doc);

      // Force top on normal link clicks.
      // If you want back/forward to ALSO go top, delete the if check.
      if (!opts.fromPopstate) {
        window.scrollTo(0, 0);
      }

      // IMPORTANT: execute only explicitly allowed scripts inside the swapped main
      runMarkedScripts(scope);

      await Promise.race([waitForReady(scope), new Promise((r) => setTimeout(r, 700))]);

      fireAfterSwap(scope);
    } catch (e) {
      console.error("[PT]", e);
      hard = true;
      location.assign(url);
    } finally {
      if (!hard) {
        pt.classList.remove("pt--loading");
        unveil();
      }
      isNavigating = false;
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      if (e.defaultPrevented) return;
      const a = e.target.closest("a");
      if (shouldSkip(a, e)) return;
      e.preventDefault();
      pjax(a.href, { fromPopstate: false });
    },
    true
  );

  window.addEventListener("popstate", function () {
    pjax(location.href, { fromPopstate: true });
  });

  // Initial hard-load unveil
  gsap.set(path, { attr: { d: P.s2f } });
  if (text) gsap.set(text, { autoAlpha: 0 });
  waitForReady(document).then(() => unveil());
})();
